<template>
  <BaseModal
    v-if="details"
    is-open
    close-on-esc-key-click
    title="Pricing details"
    @close="close"
  >
    <div class="flex flex-col gap-6 mt-4">
      <section v-if="details.pricingComment">
        <h3 class="m-0 mb-2 text-init font-semibold">
          Note from Event Manager
        </h3>
        <p class="m-0 text-sm leading-6 whitespace-pre-line wrap-anywhere">
          {{ details.pricingComment }}
        </p>
      </section>

      <section v-if="details.packagesComment">
        <h3 class="m-0 mb-2 text-init font-semibold">
          Package per person
        </h3>
        <p class="m-0 text-sm leading-6 whitespace-pre-line wrap-anywhere">
          {{ details.packagesComment }}
        </p>
      </section>
    </div>

    <template #actions>
      <div class="w-full flex justify-end">
        <BaseButton color="white" @click="close">
          Got it
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';

import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';
import BaseModal from '@/components/Ui/Modals/BaseModal.vue';
import { PricingDetails } from '@/modules/public/enquiry-form/enquiry-form.types';

const details = ref<PricingDetails | null>(null);

const close = (): void => {
  details.value = null;
};

onMounted(() => {
  window.triggerShowPricingDetailsModal = (next: PricingDetails): void => {
    // The comments live in hidden markup for SEO, so an empty pair means the crawler-facing text was
    // blank and the modal would open with nothing but a heading-less shell.
    if (!next.pricingComment && !next.packagesComment) return;
    details.value = next;
  };
});

onBeforeUnmount(() => {
  delete window.triggerShowPricingDetailsModal;
});
</script>
